import React from 'react';

const KitchenPlayerContext = React.createContext({
  streamOptions: [],
  streamsLoading: false,
  eventOptions: [],
  setEventOptions: () => {},
  eventDetails: null,
  setEventDetails: () => {},
});

export default KitchenPlayerContext;
